import { render, staticRenderFns } from "./VehicleActionTypesPage.vue?vue&type=template&id=1bc36bad&scoped=true&"
import script from "./VehicleActionTypesPage.vue?vue&type=script&lang=js&"
export * from "./VehicleActionTypesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc36bad",
  null
  
)

export default component.exports